import React from "react";
import { Link } from "@remix-run/react";

export default function Notice() {
  return (
    <div
      style={{ zIndex: 2 }}
      className="col bg-tertiary position-relative d-flex justify-content-center w-100"
    >
      <p className="mb-0 p-1 text-white text-center">
        ⚡  Major update <strong>Headlockr 5</strong>  is out now. Passkeys and more are here. Click{" "}
        <Link to="#installation" className="fw-bold text-white text-decoration-underline">
          here
        </Link>{" "}
        to get started with the new setup.
      </p>
    </div>
  );
}
